import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BillingToDo } from '@classes/billing-to-do';
import { BillingToDoService } from 'app/core/services/billing-to-do.service';
import { UiService } from 'app/core/services/ui.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BillingMonthSelect } from '@classes/billing-month-select';
import { SelectionModel } from '@angular/cdk/collections';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageBox } from '@components/message-box/message-box.component';
import { BillingDoIt } from '@classes/billing-do-it';
import { DoItModalComponent } from '../do-it-modal/do-it-modal.component';
import { BillingType, BillingTypeName } from '@enums/billing-type.enum';

@Component({
  selector: 'app-billing-todo',
  templateUrl: './billing-todo.component.html',
  styleUrls: ['./billing-todo.component.scss'],
  styles: [`
  >>> app-billing-todo {
    height: 100%;
  }
`]
})
export class BillingTodoComponent implements OnInit {

  dataSource = new MatTableDataSource<BillingToDo>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'select',
    'billingType',
    'year',
    'month',
    'site',
    'company',
  ];
  selection = new SelectionModel<BillingToDo>(true, []);

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Output() refreshEmit = new EventEmitter<BillingToDo[]>();

  filterValues: any = {
    year: '',
    month: ''
  }

  @Input() set billingMonthSelect(filter: BillingMonthSelect | null) {
    this.selection.clear();
    // setTimeout(() => {
    if (filter) {
      this.filterValues.year = filter.year;
      this.filterValues.month = filter.month[0].month;
      this.dataSource.filter = JSON.stringify(this.filterValues);
    } else {
      this.dataSource.filter = '';
    }
    //this.selection.clear();
    // });

  }

  BillingType = BillingType;

  constructor(
    public uiService: UiService,
    private billingToDoService: BillingToDoService,
    public dialog: MatDialog,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'site': return (element.site?.name);
        case 'company': return (element.company?.name);
        case 'billingType': return (BillingTypeName.get(element.billingType));
        default: return element[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
    this.getBillingToDos(true);
  }

  private createFilter(): (billingToDo: BillingToDo, filter: string) => boolean {
    let filterFunction = function (billingToDo: BillingToDo, filter: string): boolean {
      let searchTerms = JSON.parse(filter);

      return billingToDo?.year == searchTerms.year
        && billingToDo?.month == searchTerms.month;
    }

    return filterFunction;
  }

  getBillingToDos(refreshList?: boolean) {
    this.uiService.addRouteLoading();
    this.billingToDoService.getBillingToDos().subscribe(data => {
      this.dataSource.data = data
        .sort((a, b) => (a.month || -1) - (b.month || -1))
        .sort((a, b) => (a.year || -1) - (b.year || -1));
      if (refreshList) {
        this.refreshEmit.emit(data);
      }
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    }, () => {
      this.uiService.removeRouteLoading();
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }

  onGenerate() {
    if (!this.selection.isEmpty()) {
      const data = this.selection.selected;
      const dialogRef = this.dialog.open(DoItModalComponent, {
        data,
        hasBackdrop: true
      });

      dialogRef.afterClosed().subscribe(value => {
        if (value) {
          this.selection.clear();
          this.getBillingToDos(true);
        }
      })
    }
  }

}
